import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

  transform(items: any[]): any {
    if (!items) {
      return items;
    }

    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    let sortList = items.filter(item => item.Active == true);
    //sort numeric items
    if (!(sortList.some((element) => { return isNaN(Number(element.VariationName)); })))
      sortList.sort((a, b) => Number(a.VariationName) - Number(b.VariationName));

    return sortList;
  }
}
